import { DataGrid } from "@mui/x-data-grid";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import useApiHttp from "../../../hooks/use-http";
import { useParams } from "react-router-dom";

export const NewGuestList = forwardRef(
  (
    {
      columns = [],
      type,
      guestType,
      tableReset,
      refetchTable,
      searchValue,
      setGuestList,
    },
    ref
  ) => {
    const { id: eventId } = useParams();
    const signalRef = useRef(null);
    const { sendRequest: getGuestData, isLoading: guestDataLoading } =
      useApiHttp();
    const [paginationModel, setPaginationModel] = useState({
      pageSize: 25,
      page: 0,
    });

    const [rows, setRows] = useState([]);
    const [rowCount, setRowCount] = useState(0);

    const getGuestHandler = (type, page, size) => {
      signalRef.current = new AbortController();
      getGuestData(
        {
          url: searchValue
            ? `event-attendee/attendees_search/${eventId}/${guestType}?nameQuery=${searchValue}&page=${page}&size=${size}`
            : `event-attendee/${type}/${eventId}/guests?page=${page}&size=${size}`,
          signal: signalRef.current.signal,
        },
        null,
        (data) => {
          setGuestList(data?.results || data?.data);
          if (searchValue) {
            const updateData = data?.data || [];
            setRows(
              updateData.map((item, i) => {
                return { ...item, s_no: i + 1 + page * size };
              })
            );
            setRowCount(data?.count);
          } else {
            const updateData = data?.results || [];
            setRows(
              updateData.map((item, i) => {
                return { ...item, s_no: i + 1 + page * size };
              })
            );
            setRowCount(data?.count);
          }
        },
        (err, data) => {
          console.log("data", data);
        }
      );
    };
    const handlePagination = (e) => {
      getGuestHandler(type, e.page, e.pageSize);
    };
    const tableRefetchFun = () => {
      getGuestHandler(type, paginationModel.page, paginationModel.pageSize);
      console.log("hello123ref");
    };
    const tableResetFun = () => {
      console.log("hello123reset");
      const count = paginationModel.page * paginationModel.pageSize + 1;
      if (count == rowCount) {
        getGuestHandler(
          type,
          paginationModel.page - 1 > 0 ? paginationModel.page - 1 : 0,
          paginationModel.pageSize
        );
        setPaginationModel({
          pageSize: paginationModel.pageSize,
          page: paginationModel.page - 1 > 0 ? paginationModel.page - 1 : 0,
        });
      } else {
        getGuestHandler(type, paginationModel.page, paginationModel.pageSize);
      }
    };

    useImperativeHandle(ref, () => ({
      tableRefetchFun: tableRefetchFun,
      tableResetFun: tableResetFun,
    }));

    useEffect(() => {
      getGuestHandler(type, 0, 25);
      setPaginationModel({
        pageSize: 25,
        page: 0,
      });
      return () => {
        signalRef?.current?.abort();
      };
    }, [type, searchValue]);

    return (
      <div
        style={{
          height: "calc(100vh - 300px)",
          width: "100%",
        }}
      >
        <DataGrid
          loading={guestDataLoading}
          columns={columns}
          rows={rows}
          rowCount={rowCount}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          disableColumnMenu // Disables filter and column menu options
          disableRowSelectionOnClick // Keeps rows from being selected on click
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "var(--color-primary-50)", // Set the header background color
              color: "white", // Set the header text color
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontFamily: "var(--font-families-body-sbold)",
              fontSize: "var(--font-sizes-body-sbold)",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none", // Remove the border from individual cells
            },
            "& .MuiDataGrid-columnSeparator": {
              display: "none", // Remove the separator lines between column headers
            },
            "& .MuiDataGrid-cell:focus": {
              outline: "none", // This removes the active border on focus
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none", // This removes the active border on focus
            },
            // Scrollbar Styling
            "& .MuiDataGrid-virtualScroller": {
              "&::-webkit-scrollbar": {
                width: "8px", // Width of the scrollbar
                height: "8px", // Height for horizontal scrollbar
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0, 0, 0, 0.3)", // Color of the thumb
                borderRadius: "10px", // Optional: round the thumb
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1", // Track color
              },
              // Firefox styling
              scrollbarWidth: "thin", // Thin scrollbar
              scrollbarColor: "rgba(0, 0, 0, 0.3) #f1f1f1", // Thumb and track colors
            },
          }}
          pageSizeOptions={[25, 50, 75, 100]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={(e) => {
            setPaginationModel(e);
            handlePagination(e);
          }}
        />
      </div>
    );
  }
);
